import React from "react";
//#region types
import { TabDialogContentType, DialogProps } from "models/propTypes/dialogPropTypes";
import { CommonEnums } from "models/enums";
//#endregion
//#region components
import TabEvents from "../tabs/tabEvents";
import DialogLayout from "./_layout";
import TabTop from "../tabs/tabTop";
import TabPanel from "../tabs/tabPanel";
import { ErrorBoundary } from "components/error";
//#endregion
import cssExports from "theme/styles/main.module.scss";

class TabContentDialog extends React.Component<DialogProps, {}> {
  onEnterHandler = (resetTabIndex: () => void) => {
    resetTabIndex();
    if (this.props.onEnterHandler) this.props.onEnterHandler();
  };

  render() {
    return (
      <TabEvents
        render={(currentIndex, onTabChange, resetTabIndex) => (
          <DialogLayout
            {...this.props}
            header={
              <TabTop
                tabKey={"dialog-tab"}
                value={currentIndex}
                onChange={onTabChange}
                tabs={(this.props.children as TabDialogContentType).map((item) => {
                  return {
                    text: item.title,
                    onClickHandler: item.onTabChangeHandler,
                  };
                })}
              />
            }
            class={cssExports.dialogFullHeight}
            onEnterHandler={this.onEnterHandler.bind(this, resetTabIndex)}
          >
            <React.Fragment>
              {this.props.customContent}
              {(this.props.children as TabDialogContentType).map((item, index) => {
                return (
                  <TabPanel key={index} value={currentIndex} index={index}>
                    <ErrorBoundary subComponentType={CommonEnums.SubComponentType.Dialog}>{item.content}</ErrorBoundary>
                  </TabPanel>
                );
              })}
            </React.Fragment>
          </DialogLayout>
        )}
      />
    );
  }
}

export default TabContentDialog;
